import colaTheme from './cola.theme';

const themes = {
  cola: colaTheme,
};

export default themes;
